/**
 * Base state for current module
 */
const state = {
  props:{},
  defaultProps:{},
  propOptions:{}
};

export default state;
